import { gql } from "apollo-angular";

const FILTER_SERVICE_ORDER = gql`
  query ServiceOrder(
    $company: ID!
    $reference: String
    $chAlertId: String
    $installationId: ID
    $installationReference: String
    $assignee: ID
    $status: ServiceOrderStatus
    $priority: ServiceOrderPriority
    $latitude: Float
    $longitude: Float
    $deviceMac: String
    $createdAfter: DateTime
    $createdBefore: DateTime
    $startedAfter: DateTime
    $startedBefore: DateTime
    $closedAfter: DateTime
    $closedBefore: DateTime
    $isStarted: Boolean
    $isClosed: Boolean
    $limit: Int
    $offset: Int
    $sortBy: ServiceOrderSortField
    $sortOrder: ServiceOrderSortOrder
  ) {
    serviceOrder(
      company: $company
      reference: $reference
      chAlertId: $chAlertId
      installationId: $installationId
      installationReference: $installationReference
      assignee: $assignee
      status: $status
      priority: $priority
      latitude: $latitude
      longitude: $longitude
      deviceMac: $deviceMac
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      startedAfter: $startedAfter
      startedBefore: $startedBefore
      closedAfter: $closedAfter
      closedBefore: $closedBefore
      isStarted: $isStarted
      isClosed: $isClosed
      limit: $limit
      offset: $offset
      sortBy: $sortBy
      sortOrder: $sortOrder
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          company
          reference
          chAlertId
          installationId
          installationReference
          user {
            id
            username
            firstName
            lastName
          }
          assignee {
            id
            username
            firstName
            lastName
          }
          status
          priority
          latitude
          longitude
          deviceMac
          notes
          problems
          closeNotes
          createdAt
          startedAt
          closedAt
        }
      }
    }
  }
`;

const GET_SERVICE_ORDER_INFO = gql`
  query ServiceOrder(
    $company: ID!
    $reference: String
    $chAlertId: String
    $installationId: ID
    $installationReference: String
    $user: ID
    $status: ServiceOrderStatus
    $priority: ServiceOrderPriority
    $latitude: Float
    $longitude: Float
    $deviceMac: String
    $createdAfter: DateTime
    $createdBefore: DateTime
    $startedAfter: DateTime
    $startedBefore: DateTime
    $closedAfter: DateTime
    $closedBefore: DateTime
    $isStarted: Boolean
    $isClosed: Boolean
    $limit: Int
    $offset: Int
  ) {
    serviceOrder(
      company: $company
      reference: $reference
      chAlertId: $chAlertId
      installationId: $installationId
      installationReference: $installationReference
      user: $user
      status: $status
      priority: $priority
      latitude: $latitude
      longitude: $longitude
      deviceMac: $deviceMac
      createdAfter: $createdAfter
      createdBefore: $createdBefore
      startedAfter: $startedAfter
      startedBefore: $startedBefore
      closedAfter: $closedAfter
      closedBefore: $closedBefore
      isStarted: $isStarted
      isClosed: $isClosed
      limit: $limit
      offset: $offset
    ) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          company
          reference
          chAlertId
          installationId
          installationReference
          user {
            id
            username
          }
          status
          priority
          latitude
          longitude
          deviceMac
          closeNotes
          createdAt
          startedAt
          closedAt
        }
      }
    }
  }
`;

/** Criação de OS com notes/problems (Observação e Defeitos informados), usada pela tela de OS e por Alertas **/
const CREATE_SERVICE_ORDER = gql`
  mutation ServiceOrderCreate(
    $company: ID!
    $reference: String
    $chAlertId: String
    $installationId: ID!
    $installationReference: String!
    $status: ServiceOrderStatus!
    $priority: ServiceOrderPriority!
    $latitude: Float
    $longitude: Float
    $deviceMac: String!
    $notes: String
    $problems: String
    $assignee: ID
  ) {
    serviceOrderCreate(
      input: {
        company: $company
        reference: $reference
        chAlertId: $chAlertId
        installationId: $installationId
        installationReference: $installationReference
        status: $status
        priority: $priority
        latitude: $latitude
        longitude: $longitude
        deviceMac: $deviceMac
        notes: $notes
        problems: $problems
        assignee: $assignee
      }
    ) {
      serviceOrder {
        id
        company
        reference
        chAlertId
        installationId
        installationReference
        user {
          id
          username
        }
        assignee {
          username
          id
          firstName
        }
        status
        priority
        latitude
        longitude
        deviceMac
        notes
        problems
        closeNotes
        createdAt
        startedAt
        closedAt
      }
    }
  }
`;

const UPDATE_SERVICE_ORDER = gql`
  mutation ServiceOrderUpdate(
    $id: ID!
    $company: ID!
    $reference: String
    $chAlertId: String
    $installationId: ID
    $installationReference: String
    $status: ServiceOrderStatus
    $priority: ServiceOrderPriority
    $latitude: Float
    $longitude: Float
    $deviceMac: String
    $notes: String
    $problems: String
    $assignee: ID
  ) {
    serviceOrderUpdate(
      input: {
        id: $id
        company: $company
        reference: $reference
        chAlertId: $chAlertId
        installationId: $installationId
        installationReference: $installationReference
        status: $status
        priority: $priority
        latitude: $latitude
        longitude: $longitude
        deviceMac: $deviceMac
        notes: $notes
        problems: $problems
        assignee: $assignee
      }
    ) {
      serviceOrder {
        id
        company
        reference
        chAlertId
        installationId
        installationReference
        user {
          id
          username
          firstName
          lastName
        }
        assignee {
          id
          username
          firstName
          lastName
        }
        status
        priority
        latitude
        longitude
        deviceMac
        notes
        problems
        closeNotes
        createdAt
        startedAt
        closedAt
      }
    }
  }
`;

const ADD_SERVICE_ORDER_TO_ALERT = gql`
mutation ServiceOrderAddAlert (
							$id: ID!,
							$alerts: [ID],
							$clientMutationId: String
						) {
							serviceOrderAddAlert (
								input: {
									id: $id,
									alerts: $alerts,
									clientMutationId: $clientMutationId
								}) {
								serviceOrder {
									id
									status
								}
							}
						}`;

const START_SERVICE_ORDER = gql`
mutation ServiceOrderStart(
    $id: ID!
){
  serviceOrderStart(input: {
    id: $id
  }) {
    serviceOrder {
        id
        company
        reference
        chAlertId
        installationId
        installationReference
        status
        priority
        latitude
        longitude
        deviceMac
        closeNotes
        createdAt
        startedAt
        closedAt
    }
  }
}`;

const CLOSE_SERVICE_ORDER = gql`
mutation ServiceOrderClose(
    $id: ID!,
    $closeNotes: String!,
    $withIssues: Boolean
){
  serviceOrderClose(input: {
    id: $id
    closeNotes: $closeNotes
    withIssues: $withIssues
  }) {
    serviceOrder {
        id
        company
        reference
        chAlertId
        installationId
        installationReference
        status
        priority
        latitude
        longitude
        deviceMac
        closeNotes
        createdAt
        startedAt
        closedAt
    }
  }
}`;

/**
 * Instalação para a tela de OS: autocomplete (plaqueta/serial), hidratação da Ficha (por ID) e
 * painel lateral. Só os campos que a tela usa: o FILTER_INSTALLATIONS completo traz ~50 campos
 * (circuitBox, parentInstallation, endereço inteiro do gateway...) e pesava a cada abertura.
 * Ordenação omitida de propósito: a busca é por igualdade ou por "contém" com página pequena.
 **/
const SERVICE_ORDER_INSTALLATION_LOOKUP = gql`
  query ServiceOrderInstallationLookup(
    $company: ID!
    $installations: [ID]
    $referenceContains: String
    $serialNumber: String
    $pageSize: Int
  ) {
    installation(
      company: $company
      installations: $installations
      referenceContains: $referenceContains
      serialNumber: $serialNumber
      pageSize: $pageSize
    ) {
      edges {
        node {
          id
          reference
          isActive
          site {
            street
            number
            district
            city
            state
            geoposition {
              latitude
              longitude
            }
          }
          device {
            serialNumber
            macAddress
            equipmentType {
              reference
            }
          }
          gateway {
            reference
          }
          lampType {
            power
            model
            manufacturer
          }
        }
      }
    }
  }
`;

/**
 * Técnico responsável da OS: busca por login, nome ou sobrenome num termo só (arg `search` do
 * bifrost). A tela exibe o nome, então buscar só por `username_Icontains` não achava quem o
 * operador lia na tabela.
 **/
const SEARCH_SERVICE_ORDER_USERS = gql`
  query ServiceOrderUsers($search: String, $first: Int) {
    user(search: $search, first: $first) {
      edges {
        node {
          id
          username
          firstName
          lastName
        }
      }
    }
  }
`;

/** Usuários da empresa para responsável de OS na importação em lote. Paginada: o graphene
 *  devolve no máximo 100 por página, então quem consome segue `pageInfo` até o fim. **/
const SERVICE_ORDER_COMPANY_USERS_PAGE = gql`
  query ServiceOrderCompanyUsersPage($company: ID, $first: Int, $after: String) {
    user(company: $company, first: $first, after: $after) {
      pageInfo { hasNextPage endCursor }
      edges {
        node {
          id
          username
          firstName
          lastName
        }
      }
    }
  }
`;

export {
  // Queries
  FILTER_SERVICE_ORDER,
  GET_SERVICE_ORDER_INFO,
  SERVICE_ORDER_INSTALLATION_LOOKUP,
  SEARCH_SERVICE_ORDER_USERS,
  SERVICE_ORDER_COMPANY_USERS_PAGE,
  // Mutations
  CREATE_SERVICE_ORDER,
  UPDATE_SERVICE_ORDER,
  ADD_SERVICE_ORDER_TO_ALERT,
  START_SERVICE_ORDER,
  CLOSE_SERVICE_ORDER
};